import React, { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { compose } from 'redux';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import Input from '../../../components/Form/Input';
import Button from '../../../components/Button';
import { startAction } from '../../../saga/actions/workflow';
import { getHTTPErrorMessage } from '../../../utils/fetch';
import { appConfig } from '../../../appConfig';

const Intro = (props) => {
  const { search } = useLocation();
  const offerCode = new URLSearchParams(search).get('offerCode') || '';

  // get functions to build form with useForm() hook
  const hookForm = useForm();
  const { handleSubmit, setValue } = hookForm;
  // set initial values
  useEffect(() => {
    setValue('code', offerCode);
    localStorage.removeItem('isInProgress');
    localStorage.removeItem('key');
  }, [setValue, offerCode]);

  // handle functions
  const postMessage = (offerCodeValue) => {
    if (window.parent) {
      window.parent.postMessage({
        type: 'DIRECT_MAIL_DTC',
        dtcDirectMailUrl: `${window.location.origin}/main`,
        query: offerCodeValue ? `?offerCode=${offerCodeValue}` : '',
      }, appConfig.businessUrl);
    }
  };
  const handleCodeChange = (e) => {
    const val = e.target.value;
    setValue('code', val.replace(/\s/g, ''));
  };
  const handleNoOfferCode = () => {
    postMessage(null);
  };
  const onSubmit = (data) => {
    props.startAction({
      url: '/workflows/direct-mail/dtc-mailer/start',
      method: 'POST',
      data: {
        offerCode: data.code,
      },
      success: () => {
        postMessage(data.code);
      },
      fail: () => {},
    });
    return false;
  };
  const errorMsg = getHTTPErrorMessage(
    props.workflow.error, (
      <div>
        Please enter a valid offer code. If you don&apos;t have an offer code,
        <span onClick={handleNoOfferCode} className="ml-[4px] mr-[4px] underline font-bold cursor-pointer">click here to apply</span>
        or call us at 888-811-8798
      </div>
    )
  );

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-[10px]">
      <div className="text-left font-bold text-[14px] leading-[16px] text-[#000A2F] tracking-tight">Enter your offer code to check your rate</div>
      <div className="flex">
        <Input
          autoFocus
          name="code"
          placeholder="Enter your offer code here"
          label=""
          className="mt-0 w-3/5"
          hookForm={hookForm}
          registerOptions={{ required: 'Offer Code is required', onChange: handleCodeChange }}
        />
        <Button isLoading={props.workflow.isLoading} type="submit" className="w-2/5 h-[46px] leading-[16px] ml-[10px] mt-[13px]">Check Your Rate Now</Button>
      </div>
      {errorMsg && <div className="text-[#d71f28] text-xs bg-[#FEF4F3] p-[10px] mt-[18px]">{errorMsg}</div>}
      <div className="mt-[10px]">
        <span className="cursor-pointer text-[#000A2F] underline" onClick={handleNoOfferCode}>I do not have an offer code</span>
      </div>
    </form>
  );
};

Intro.propTypes = {
  workflow: PropTypes.object.isRequired,
  startAction: PropTypes.func.isRequired,
};

export default compose(
  connect(
    (state) => ({
      workflow: state.workflow,
    }),
    {
      startAction,
    }
  )
)(Intro);
